import { mergeDeepRight } from 'ramda';
import { environment as _default } from './environment.default';
export const environment = mergeDeepRight(_default, {
  production: true,
  auth: {
    authority: 'https://acciona-sb.onelogin.com/oidc/2',
    oneLoginWellKnownUrl: 'https://acciona-sb.onelogin.com/oidc/2',
    clientID: '3c5e0890-a30c-013c-8535-56f5c2a9a62838690',
    redirectUri: 'https://canales-int.acciona-energia.com',
    postLogoutRedirectUri: 'https://canales-int.acciona-energia.com',
    scopes: 'openid profile email',
    protectedResourceMap: [ 'https://canales-int.acciona-energia.com' ],
    omniChannelDataAppId: '4d1b1643-bd43-4591-9da8-5433e710a78f',
    omniChannelDataOrgId: '4c89471c-6612-4ec5-911c-7a3d973cec1d',
    omniChannelDataOrgUrl: 'https://m-4c89471c-6612-4ec5-911c-7a3d973cec1d.eu.omnichannelengagementhub.com',
  },
  prefixes: {
    default: 'https://canales-api-int.acciona-energia.com/backend/api',
    identity: 'https://canales-api-int.acciona-energia.com/backend/api',
  }
});
